import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { onAuthStateChanged, User } from "firebase/auth";
import { useEffect, useMemo, useState } from "react";
import { auth } from "../config/firebase-config";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

type CustomClaims = {
    superadmin?: boolean;
    companyAccess?: Record<string, number>;
    agencyAccess?: Record<string, number>;
    [key: string]: any; // for feature falgs like feature_shopify
}

export const useAuth = () => {
    const [currentUser, setCurrentUser] = useState<User | null | undefined>();
    const [claims, setClaims] = useState<CustomClaims | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const loadClaims = async (force = false) => {
        if (!auth.currentUser) return;
        const idTokenResult = await auth.currentUser.getIdTokenResult(force);
        setClaims(idTokenResult.claims as CustomClaims);
    };

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
            console.log("Auth Stat Changed")
            setCurrentUser(firebaseUser);
            setLoading(true);
            if (firebaseUser) loadClaims()
            setLoading(false)
        });

        return unsub;
    }, []);

    // ✅ Return a memoized user to prevent new reference unless value changes
    const memoizedUser = useMemo(() => currentUser, [currentUser]);

    return {
        currentUser: memoizedUser,
        claims: claims,
        loading: loading,
        reloadClaims: () => loadClaims(true)
    };
};